export class ChangePassword {
    public oldPassword!: string;
    public password!: string;
    public userId!: number;
}